import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "create-video-sidebar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text" }

import { ref, computed } from 'vue';
import { useRoute, } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'sideBar',
  emits: ['onNavChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const route = useRoute();

const emit = __emit;
const activeName = ref(0);
const navs = [
  {
    text: '数字人',
    iconName: 'digitalMan',
    component: 'DigitalMan',
    activeIconName: 'digitalManActive',
    index: 0,
  },
  {
    text: '背景',
    iconName: 'background',
    component: 'Background',
    activeIconName: 'backgroundActive',
    index: 1,
  },
  // {
  //   text: '我的资源',
  //   iconName: 'source',
  //   component: 'Source',
  //   activeIconName: 'sourceActive',
  //   index: 2
  // },
  {
    text: '装饰',
    iconName: 'tiezhi',
    component: 'Logo',
    activeIconName: 'tiezhiActive',
    index: 3,
  },
  // {
  //   text: '音乐',
  //   iconName: 'music',
  //   component: 'Music',
  //   activeIconName: 'musicActive',
  //   index: 4
  // },
  // {
  //   text: '文字',
  //   iconName: 'text',
  //   component: 'Text',
  //   activeIconName: 'textActive',
  //   index: 5
  // }
  {
    text: 'AI剪辑',
    iconName: 'ai-clip',
    component: 'ResourcesVideo',
    activeIconName: 'ai-clip-active',
    index: 6,
  },
]

// 工具面板类型
let navsTypeObj = {
  'aiClip': ['DigitalMan', 'Logo', 'ResourcesVideo'],
  'default': ['DigitalMan', 'Logo', 'Background']
}
let navsList = computed(() => {
  let navsType = route.query?.navsType || 'default'
  return navsType && navsTypeObj[navsType] ? navs.filter(v => navsTypeObj[navsType].includes(v.component)) : navs
})
const changeModule = (nav) => {
  activeName.value = nav.index;
  emit('onNavChange', nav.component);
};
// 定义暴露给父组件的对象
__expose({
  changeModule,
});

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navsList), (nav) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass(["flex-column-box", activeName.value == nav.index && 'active']),
        key: nav.index,
        onClick: ($event: any) => (changeModule(nav))
      }, [
        _createVNode(_component_svgIcon, {
          iconClass: activeName.value == nav.index ? nav.activeIconName : nav.iconName,
          width: "1.458vw",
          height: "1.458vw"
        }, null, 8, ["iconClass"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(nav.text), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})